import React, { useEffect, useState } from 'react'

import NavBar from '../components/navbar/NavBar'
import StarParalax from '../components/starparalax/StarParalax'
import Footer from '../components/footer/Footer'
import ScrollTop from '../components/scrolltop/ScrollTop'
import SearchBar from '../components/searchbar/SearchBar'
import ArtistAvatar from '../components/artistavatar/ArtistAvatar'

import Slider from "react-slick";

import ExclusiveDrops from '../components/exclusivedrops/ExclusiveDrops'
import HotAuction from '../components/hotauction/HotAuction'
import FilterButton from '../components/filterbutton/FilterButton'
import ExploreImage from '../components/exploreimage/ExploreImage'
import BuyImage from '../assets/images/buy.png'
import BnbReward from '../assets/images/bnbreward.png'

const Home = () => {

    var settings = {
        centerMode: true,
        centerPadding: '5px',
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        slide: '> div',
        adaptiveHeight: true,

        responsive: [{
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                centerPadding: '20px',
                slidesToScroll: 1,
            }
        }]

    };

    return (
        <>
            <div className="landing-page-main">
                <NavBar />
                <div className="main-hero">
                    <div className="container">
                        <div className="buy-container">
                            <div id="animated-buy" class="animated bounce">
                                <a href="https://pancakeswap.finance/swap?outputCurrency=0x241b8e70e25495bb347b3e267ad2e27dcc3b2506" target="_blank"><img src={BuyImage} alt="" /></a>
                            </div>
                        </div>
                        <div className="bnb-reward-container">
                            <div className="fire-cotainer">
                                <div class="fire">
                                    <div class="fire-left">
                                        <div class="main-fire"></div>
                                        <div class="particle-fire"></div>
                                    </div>
                                    <div class="fire-main">
                                        <div class="main-fire"></div>
                                        <div class="particle-fire"></div>
                                    </div>
                                    <div class="fire-right">
                                        <div class="main-fire"></div>
                                        <div class="particle-fire"></div>
                                    </div>
                                    <div class="fire-bottom">
                                        <div class="main-fire"></div>
                                    </div>
                                </div>
                            </div>
                            <a href="#" target="_blank"><img src={BnbReward} alt="" /></a>
                        </div>

                    </div>
                </div>

                <Footer />
                {/* <ScrollTop /> */}
            </div>

        </>
    )
}

export default Home
